import * as serviceContext from '../services/serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';
import {deckHerosApi, realGamesApi, OPERATOR_ID} from '../configs/const';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;
export async function getAffiliateRequestList() {
    try {
        const response = await serviceContext.get(`affiliate/users/getpending`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function approvedAffiliateRequest(data) {
    try {
        const response = await serviceContext.post(`affiliate/users/update`, JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function getAffiliateApprovedList(data) {
    try {
        const response = await serviceContext.get(`affiliate/users/getapproved/${data}`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function updateAffiliateUserStatusApi(data) {
    try {
        const response = await serviceContext.post(`affiliate/users/updatestatus`, JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function getAffiliateClientList(data) {
    try {
        const response = await serviceContext.get(`affiliate/operatorclient/getlist${!!data? '/' + data :''}`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function getAffiliateReport(data) {
    try {
        const response = await serviceContext.post(`${ReportsURL}filteruser/count`, JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function updateAffiliate(data) {
    try {
        const response = await serviceContext.post(`affiliate/users/updatedetails`, JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getAffiliateClientReport(data) {
    try {
        const response = await serviceContext.post(`${ReportsURL}client/depo/with/pnl/report`, JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};